var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMegaphone(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2256,
    height: 2366,
    viewBox: "0 0 2256 2366",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1589.04 2356.75L1400.41 2218.42C1380.35 2203.71 1375.02 2176.03 1388.18 2154.93L1615.87 1789.68C1632.85 1762.44 1618.51 1726.54 1587.43 1718.5L35.6591 1316.8C4.93534 1308.84 -9.52008 1273.6 6.77241 1246.36L738.52 23.1405C754.633 -3.79532 791.964 -8.00202 813.668 14.6723L2232.55 1497L2236.83 1500.54C2242.38 1505.13 2246.81 1510.92 2249.79 1517.48L2251.56 1521.36C2258.18 1535.9 2257.05 1552.79 2248.56 1566.32L2090.42 1818.42C2079.48 1835.85 2058.58 1844.27 2038.61 1839.28L1988.41 1826.73C1967.63 1821.53 1945.94 1830.87 1935.44 1849.54L1658.59 2341.72C1644.61 2366.57 1612.04 2373.61 1589.04 2356.75Z",
    fill: "#FF6B00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphone);
export default __webpack_public_path__ + "static/media/megaphone.af9b8f6b79cd742c5a0b12cb662332d2.svg";
export { ForwardRef as ReactComponent };